/**
 * What a watched video's audio is called and the message that follows its upload. Plain .ts so
 * `node --test` can load it.
 */

/** The video's name without spaces or brackets, so the uploaded path is a single argument. */
export function audioNameFor(videoName: string): string {
	const dot = videoName.lastIndexOf(".");
	const stem = dot > 0 ? videoName.slice(0, dot) : videoName;
	const safe = stem
		.replace(/[^\w.\-一-龥]+/g, "-")
		.replace(/-+/g, "-")
		.replace(/^-|-$/g, "");
	return `${safe || "video"}.m4a`;
}

/** The path goes first because it has no spaces; everything after it is the video's name. */
export function openingMessage(opening: string, audioPath: string, videoName: string): string {
	return `${opening} ${audioPath} ${videoName}`;
}
